<template>
    <div class="ne-node-map-container nkn-explorer-card-shadow"></div>
</template>

<script>
  import $ from 'jquery'
  export default {
    name: "nkn-node-map",
    props:["geoList"],
    data() {
      return {
        nodeMap: null,
        markersLayer: null,
        isMapInRendering: false
      }
    },
    mounted() {
      let _this = this;
      this.$nextTick(function () {

        let initZoom = 0
        let noWap = true
        if($(window).width() > 768) {
          initZoom = 2
          noWap = false
        }
        this.nodeMap = L.map(this.$el).setView([0, 0], initZoom);
        L.tileLayer('https://{s}.tile.osm.org/{z}/{x}/{y}.png', {
          attribution:
          '&copy; <a target="_blank" href="https://osm.org/copyright">OpenStreetMap</a> contributors',
          minZoom: 0,
          tap: false,
          scrollWheelZoom: false,
          noWrap: false,
        }).addTo(this.nodeMap);

        if(this.geoList.length > 0) {
            this.updateMap();
        }
      })
    },
      beforeDestroy() {
          //console.log("nknNodeMap beforeDestroy...");
          this.clearNodeMap();
      },
      destroyed() {
          //console.log("nknNodeMap destroyed...");
      },
    watch: {
      geoList() {
        this.updateMap()
      }
    },
    methods: {
        sleepForMillisecond : async function(duration) {
            //console.log("sleep for ", duration , " millisecond")
            return new Promise(function (resolve, reject) {
                setTimeout(resolve, duration);
            });
        },
        clearNodeMap: function() {
            console.log("do clearNodeMap...")
            if(null != this.nodeMap && null != this.markersLayer) {
                this.nodeMap.eachLayer(function(layer) {
                    if(layer.clearLayers != null) {
                        layer.clearLayers();
                    }
                });
                this.nodeMap.removeLayer(this.markersLayer);
            }
        },
        updateMap:async function () {
            let _this = this;
            if(_this.isMapInRendering) {
                return;
            }
            _this.isMapInRendering = true;
            console.log(new Date(), "......updateMap start.......");
            if(null !== this.markersLayer) {
                this.nodeMap.removeLayer(this.markersLayer)
            }

            let maxClusterRadius = 10
            if($(window).width() > 768) {
                maxClusterRadius = 20
            }

            this.markersLayer = L.markerClusterGroup({
                maxClusterRadius: maxClusterRadius,
                iconCreateFunction: (cluster) => {
                    let maxAdd = 24
                    if($(window).width() > 768) {
                        maxAdd = 48
                    }

                    let iconClass = ''
                    let weight = (cluster._childCount / this.$store.state.map.geo.totalNodeCount)
                    //let pointWidth = 12 + weight * maxAdd;
                    let pointWidth = 20;
                    if(weight < 0.10) {
                        iconClass = 'map-icon marker-cluster-small'
                    } else if(weight < 0.20) {
                        iconClass = 'map-icon marker-cluster-medium'
                    } else {
                        iconClass = 'map-icon marker-cluster-large'
                    }

                    if(cluster._childCount > 4000) {
                        //iconClass += ' marker-cluster-super-large'
                        pointWidth = $(window).width() > 768 ? 40 : 30;
                    } else if(cluster._childCount > 2000) {
                        pointWidth = $(window).width() > 768 ? 36 : 27;
                    } else if(cluster._childCount > 1000) {
                        pointWidth = $(window).width() > 768 ? 32 : 24;
                    } else if(cluster._childCount > 100) {
                        pointWidth = $(window).width() > 768 ? 28 : 21;
                    } else {
                        pointWidth = $(window).width() > 768 ? 24 : 18;
                    }
                    return L.divIcon({ html: `<span>${cluster._childCount}</span>`, className: iconClass, iconSize: L.point(pointWidth, pointWidth) });
                },
            });

            let geoListLen = this.geoList.length;
            let cntEveryFrame = parseInt(geoListLen/2);

            for (let i = 0; i < geoListLen; i++) {
                let latlng = this.geoList[i]
                let title = latlng.IPAddress
                let marker = L.marker(new L.LatLng(latlng.Lat, latlng.Lon), {
                    title: title,
                    icon: L.divIcon({ html: '', className: 'map-icon-node'})
                });
                marker.bindPopup(title);
                this.markersLayer.addLayer(marker);
                if(i > 0 && i % cntEveryFrame == 0) {
                    console.log(`render the map, sleep 50 ms: ${i}/${geoListLen}`);
                    await this.sleepForMillisecond(50);
                }
            }
            this.nodeMap.addLayer(this.markersLayer);
            _this.isMapInRendering = false;
            console.log(new Date(), "......updateMap end.....");
        }
    }
  }
</script>

<style scoped>
    .ne-node-map-container {
        height: 400px;
        width: 100%;
    }
    @media screen and (max-width: 768px) {
        .ne-node-map-container {
            height: 260px;
            width: 100%;
            background-color:#b2d2dd !important;
        }

        .leaflet-control-zoom.leaflet-bar.leaflet-control {
            margin-top: 10px !important;
            margin-left: 10px !important;
        }
    }
</style>

<style>
    .map-icon-node {
      background-color: rgb(86, 147, 237);
      border-radius: 50%;
      width: 10px !important;
      height: 10px !important;
      text-align: center;
      /*font-size:8px;*/
    }

    .map-icon {
      border-radius: 50%;
      text-align: center;
      font-size: 0 !important;
      display:flex;
      justify-content:center;
      align-items:center;
    }

    .map-icon span {
      font-size: 12px;
      display: inline-block;
      /*overflow: hidden;*/
      line-height: 30px;
      text-overflow:ellipsis;
    }

    @media screen and (max-width: 768px) {
        .leaflet-control-zoom.leaflet-bar.leaflet-control {
            margin-top:6px !important;
            margin-left:6px !important;
        }

        .map-icon-node {
            background-color: rgb(86, 147, 237);
            border-radius: 4px;
            width: 10px !important;
            height: 10px !important;
            font-size:6px;
        }

        .map-icon span {
          transform: scale(0.75) !important;
          line-height: 24px;
        }
    }

    .marker-cluster-small {
        background-color: rgba(181, 226, 140, 0.6);
        border: 2px solid rgba(110, 204, 57, 0.6);
    }

    .marker-cluster-medium {
        background-color: rgba(241, 211, 87, 0.6);
        border: 2px solid rgba(240, 194, 12, 0.6);
    }

    .marker-cluster-large {
        background-color: rgba(253, 156, 115, 0.6);
        border: 2px solid rgba(241, 128, 23, 0.6);
    }

</style>



// WEBPACK FOOTER //
// src/components/home/plugins/nknNodeMap.vue